import { RetryLink } from 'apollo-link-retry'

type TRetryContext = {
  disableRetry?: boolean
}

const INITIAL_DELAY_MS = 300

/**
 * Creates a RetryLink that allows per-operation opt-out via context.disableRetry
 */
export function createRetryLink() {
  return new RetryLink({
    delay: {
      initial: INITIAL_DELAY_MS,
      max: Infinity,
      jitter: true,
    },
    attempts: {
      max: 5,

      // @see https://github.com/apollographql/apollo-link/blob/master/packages/apollo-link-retry/README.md#custom-strategies
      retryIf: (error, operation) => {
        const context = operation.getContext() as TRetryContext
        if (context.disableRetry) {
          return false
        }

        return Boolean(error)
      },
    },
  })
}
